import axios from "axios";

const baseUrl = process.env.REACT_APP_BASE_URL;

export const fetchModelPosts = async () => {
  return await axios.get(`${baseUrl}/mopic/model`);
};
